import axios from 'axios'

import { AddressTypesByCountryInterface } from '../Interfaces/EInvoiceInterface'
import { getRequestConfig } from './index'

export async function getAddressTypes(): Promise<AddressTypesByCountryInterface> {
  const response = await axios.get('/invd/einvoice/addressTypes', getRequestConfig())
  return response.data
}
